import { useState, useEffect, useCallback } from 'react';
import { rasService } from '../services/rasService';
import { HealthResponse } from '../types/api';

interface UseHealthCheckResult {
  health: HealthResponse | null;
  loading: boolean;
  error: string | null;
  refetch: () => void;
}

export const useHealthCheck = (): UseHealthCheckResult => {
  const [health, setHealth] = useState<HealthResponse | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchHealth = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);
      const healthData = await rasService.getHealth();
      setHealth(healthData);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to fetch health status');
      setHealth(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchHealth();

    // Auto-refresh every 6 minutes (360,000ms)
    const interval = setInterval(fetchHealth, 360000);
    
    return () => clearInterval(interval);
  }, [fetchHealth]);

  return { health, loading, error, refetch: fetchHealth };
};